<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import type { PaginationDetails } from "@shared/types/Pagination";

  export let pagination: PaginationDetails = {
    goToPage: number => {},
    page: 0,
    perPage: 0,
    totalEntries: 0,
  };
  let offsetStart: number = 0;
  let offsetEnd: number = 0;
  let hasPreviousPage: boolean = false;
  let hasNextPage: boolean = false;

  $: {
    offsetStart = pagination.perPage * (pagination.page - 1) + 1;
    offsetEnd = offsetStart + pagination.perPage - 1;

    if (offsetEnd > pagination.totalEntries) {
      offsetEnd = pagination.totalEntries;
    }
  }

  function nextPage() {
    if (!hasNextPage) {
      return;
    }
    var newPage = pagination.page + 1;
    pagination.goToPage(newPage);
  }

  function previousPage() {
    if (!hasPreviousPage) {
      return;
    }
    var newPage = pagination.page - 1;

    pagination.goToPage(newPage);
  }

  $: totalCount = pagination.totalEntries.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0;

  $: {
    hasPreviousPage = pagination && pagination.page > 1;
    hasNextPage = pagination && offsetStart + pagination.perPage <= pagination.totalEntries;
  }

</script>

<div class="fizz-styles">
  <span class="fizz-flex-row-4">
    {#if offsetStart}
      <span>
        <span class="w700"
          >{offsetStart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} - {offsetEnd
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span
        >
        {#if pagination.showTotals != false}
          <span>
            of
            <span class="w700">{totalCount}</span>
          </span>
        {/if}
      </span>
    {/if}

    <button
      class="fizz-icon-button-small previous-page"
      on:click={previousPage}
      disabled={!hasPreviousPage}
    >
      <Icon width="14" height="14" type="ArrowLeft" />
    </button>
    <button class="fizz-icon-button-small next-page" on:click={nextPage} disabled={!hasNextPage}>
      <Icon width="14" height="14" type="ArrowRight" />
    </button>
  </span>
</div>
